import { ReportsType } from '@features/reports/enums/reportsType'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

export const getReportsRouteUrl = (organizationUrl: string | undefined, route: ReportsType): string => {
  const pathByRoute = {
    [ReportsType.ProfitAndLoss]: reactRoute.organization.reports.getProfitAndLossRoute(),
    [ReportsType.BalanceSheet]: reactRoute.organization.reports.getBalanceSheetRoute(),
    [ReportsType.TrialBalance]: reactRoute.organization.reports.getTrialBalanceRoute(),
  }

  return getOrganizationViewUrl(organizationUrl, pathByRoute[route])
}
